module.exports = __webpack_public_path__ + "media/placeholder-images/placeholder_3-892d8a33.jpg";